import Vue from 'vue'
import enquire from 'enquire.js'
import {endpoints} from './config'
import {breakpoints} from './config'

export default new Vue({
  name: 'Store',
  data: {
    wishlistCounter: 0,
    searchShown: false,
    searchTerm: '',
    viewport: 'palm',
  },
  created: async function() {
    const response = await fetch(endpoints.wishlistTotal, {credentials: 'include'})
    this.wishlistTotal = await response.text()
    this.mobileListener()
  },
  methods: {
    updateCounter: function(changeBy = 1) {
      this.wishlistTotal = this.wishlistTotal + changeBy
    },

    mobileListener() {
      enquire.register(`(min-width: ${breakpoints.lap})`, {
        match: () => {
          this.isMobile = false
        },
        unmatch: () => {
          this.isMobile = true
        }
      })
    },
  },
  computed: {
    isMobile: {
      get() { return (this.viewport === 'palm') },
      set(value = true) {
        this.viewport = (!!value) ? 'palm' : 'lap'
      }
    },
    wishlistTotal: {
      get() { return this.wishlistCounter },
      set(value) {
        this.wishlistCounter = value * 1 // cast to Number
      },
    },
  },
})



// WEBPACK FOOTER //
// ./sportspower/assets/es6/store.js